import React, { useEffect, useState } from 'react'
import StyledSmText from '../../common/components/styledSmText/StyledSmText'
import StyledXsText from '../../common/components/styledXsText/StyledXsText'
import Button from '../button/Button'
import ProgressBar from '../progressBar/ProgressBar'
import Skeleton from '../skeleton/Skeleton'
import { fromWeiToEther } from "../../helpers/helpers"
import { useMintingStateContext } from "../../context/CrowdfundingContext"
import { useStateContext } from "../../context/StateContext"
import { useAccount } from 'wagmi'
import { ContractAddresses } from '../../constants/contractAddresses'
import { Success } from '../toast/Success'
import { Error } from '../toast/Error'
import {
    useConnectModal,
} from '@rainbow-me/rainbowkit';

const ProjectsCard = ({ project, donate }) => {

    const [loading, setLoading] = useState(true);
    const { openConnectModal } = useConnectModal();
    const [totalBalance, setTotalBalance] = useState(null);
    const currentTimestamp = new Date().getTime()
    const isProjectOver = Number(project.targetTime) * 1000 < currentTimestamp;
    const { getBalance, giveApproval, checkAllowance, checkIsVolunteer } = useMintingStateContext()
    const { setDonateModalShow, setCurrentProject } = useStateContext()
    const account = useAccount()

    useEffect(() => {
        const loadImage = () => {
            const img = new Image();
            img.onload = () => {
                setLoading(false); // Set loading to false once the image is loaded
            };
            img.onerror = () => {
                setLoading(false); // Set loading to false if there's an error loading the image
            };
            img.src = `https://picsum.photos/id/${project.projectId}/2500/1667`;
        };

        if (project.projectId) {
            loadImage();
        }
    }, [project.projectId]);

    const getTotalBalance = async () => {
        try {
            const response = await getBalance(account?.address);
            setTotalBalance(response)
        }
        catch (error) {
            console.log("��� ~ getTotalBalance ~ error:", error)
        }
    }

    const approveWallet = async () => {
        try {
            const response = await giveApproval(
                account?.address,
                ContractAddresses.CrowdFundingAddress,
                Number(totalBalance)
            );
            return response;
        }
        catch (error) {
            console.log("��� ~ approveWallet ~ error:", error)
        }
    }

    const checkAllowanceValue = async () => {
        try {
            const response = await checkAllowance(
                account?.address,
                ContractAddresses.CrowdFundingAddress,
            );
            return response;
        }
        catch (error) {
            console.log("��� ~ approveWallet ~ error:", error)
        }
    }

    const handleDonate = async () => {
        try {
            setCurrentProject(project)
            const allowancedValue = await checkAllowanceValue()
            if (allowancedValue === 0) {
                if (!isProjectOver || project.withdawalStatus === false) {
                    await getTotalBalance()
                    const walletApproved = await approveWallet()
                    if (walletApproved?.transactionHash) {
                        Success({ text: "Congratulations", message: "Your wallet is approved" })
                    }
                    else {
                        Error({ text: "Failed", message: "Your wallet is not approved" })
                    }
                }
            }
            else {
                const response = await checkIsVolunteer(account.address)
                if (response === true) {
                    setDonateModalShow(true)
                }
                else {
                    setDonateModalShow(false)
                    Error({ text: "Failed!", message: "You are not a volunteer" })
                }
            }
        }
        catch (error) {
            console.log("🚀 ~ handleDonate ~ error:", error)
        }
    }

    return (
        <div className='relative flex flex-col w-full h-full gap-3 border border-white rounded-xl'>
            <div className={`absolute p-2 text-black top-1.5 left-1.5 rounded-lg ${project.withdawalStatus ? "bg-white" : isProjectOver ? "bg-gray" : "bg-purple"}`}>
                <StyledXsText fontColor={project.withdawalStatus ? "text-black !font-bold" : isProjectOver ? "!font-bold text-black" : "!font-bold text-white"}>{project.withdawalStatus === true ? "Closed" : isProjectOver ? "Overdue" : "Ongoing"}</StyledXsText>
            </div>
            <div className='w-full h-[200px]'>
                {loading ? (
                    <Skeleton />
                ) : (
                    <img
                        className='h-full rounded-xl'
                        width={1000}
                        src={`https://picsum.photos/id/${Number(project.projectId)}/2500/1667`}
                        alt={`Project#${Number(project.projectId)}`}
                    />
                )}
            </div>
            <div className='flex flex-col justify-between h-full gap-5 px-3'>
                <div className='flex flex-col gap-2'>
                    <div className='flex flex-col gap-2'>
                        <div className='flex justify-between'>
                            <div>
                                <StyledXsText fontColor="text-white">#{Number(project.projectId)}</StyledXsText>
                            </div>
                            <div>
                                <StyledXsText fontColor="text-white">{Number(project.supporters)} supporters</StyledXsText>
                            </div>
                        </div>
                        <div className='flex flex-col gap-1'>
                            <div>
                                <ProgressBar raisedFunds={fromWeiToEther(project.raisedFunds)} requiredFunds={fromWeiToEther(project.requiredFunds)} />
                            </div>
                            <div className='flex justify-between'>
                                <div>
                                    <StyledXsText fontColor="text-white !text-[10px]">Raised: {fromWeiToEther(project.raisedFunds)} HOPE</StyledXsText>
                                </div>
                                <div>
                                    <StyledXsText fontColor="text-white !text-[10px]">Required: {fromWeiToEther(project.requiredFunds)} HOPE</StyledXsText>
                                </div>
                            </div>
                        </div>
                        <div>
                            <StyledSmText fontColor="text-white !font-bold">{project.projectName}</StyledSmText>
                        </div>
                    </div>
                    <hr />
                    <div>
                        <StyledXsText fontColor="text-white">{project.projectDescription}</StyledXsText>
                    </div>
                </div>
                <div className="flex flex-col gap-2 pb-3">
                    <div className='grid flex-wrap grid-cols-3 gap-2'>
                        {
                            project.tags.map((tag, index) => (
                                <div className='w-full p-2 text-center bg-white rounded-xl' key={index}>
                                    <StyledXsText fontColor="text-black !text-[10px]">{tag.length > 7 ? tag.slice(0, 7) + ".." : tag}</StyledXsText>
                                </div>
                            ))
                        }
                    </div>
                    {donate &&
                        <div>
                            <Button onClick={!account.isConnected ? openConnectModal : handleDonate} disabled={isProjectOver || project.withdawalStatus === true} variant="button-gradient" fontColor="flex items-center gap-3 justify-center rounded-xl text-md text-black">{!account.isConnected ? "Connect Wallet" : "Donate"}</Button>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default ProjectsCard
